// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#root_block,#root_block>.ant-spin-container{width:100%}.ant-tabs-bar{margin:0!important}", ""]);
// Exports
module.exports = exports;
